import React, { useEffect, useMemo, useRef } from 'react'
import { buildExportSvg } from '../../services/exportSvg'

export default function ExportPreview({
  rawViz,
  brandTheme,
  chartId,
  mapping,
  dataTypes,
  visualOptions,
  chartColorSyncMode = 'brand',
  recolorMarks = true,
}) {
  const containerRef = useRef(null)
  const previewSvg = useMemo(
    () =>
      buildExportSvg(rawViz, brandTheme, {
        chartId,
        mapping,
        dataTypes,
        visualOptions,
        chartColorSyncMode,
        recolorMarks,
      }),
    [rawViz, brandTheme, chartId, mapping, dataTypes, visualOptions, chartColorSyncMode, recolorMarks]
  )

  useEffect(() => {
    const container = containerRef.current
    if (!container) return undefined

    container.innerHTML = ''
    if (!previewSvg) return undefined

    const mountedSvg = previewSvg.cloneNode(true)
    mountedSvg.style.width = '100%'
    mountedSvg.style.maxWidth = '100%'
    mountedSvg.style.height = 'auto'
    mountedSvg.style.display = 'block'
    mountedSvg.style.overflow = 'visible'
    mountedSvg.removeAttribute('id')
    container.appendChild(mountedSvg)

    return () => {
      container.innerHTML = ''
    }
  }, [previewSvg])

  if (!previewSvg) {
    return (
      <div className="chart-preview preview-stage-shell">
        <div className="chart-preview-stage preview-stage">
          <div className="text-muted small">
            Finish mapping the chart to preview the final export output.
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="chart-preview preview-stage-shell">
      <div className="chart-preview-stage preview-stage" ref={containerRef} />
    </div>
  )
}
